// The frame of the pages that sign people in: TUNE's mark, the page's title, and its form, in a card in the middle
// of a desktop, or across a phone.
import type { ReactNode } from 'react';
import { Link } from 'react-router';
import s from './AuthFrame.module.css';
import { usePageTitle } from './title';

export function AuthFrame({
  title,
  subtitle,
  children,
  footer,
  tab,
}: {
  title: string;
  subtitle?: ReactNode;
  children: ReactNode;
  /** Below the card: links elsewhere. */
  footer?: ReactNode;
  /** The browser's name for the page, when it says more than the title. */
  tab?: string;
}) {
  usePageTitle(tab ?? title);
  return (
    <div className={s.frame}>
      <main id="main" tabIndex={-1} className={s.main}>
        <div className={s.card}>
          <Link to="/" className={s.brand}>
            <img src="/logo.avif" alt="" width={46} height={26} />
            <span>TUNE Analytics</span>
          </Link>
          <div className={s.head}>
            <h1 className={s.title}>{title}</h1>
            {subtitle && <p className={s.subtitle}>{subtitle}</p>}
          </div>
          {children}
        </div>
        <footer className={s.footer}>
          {footer}
          <Link to="/help">Help</Link>
        </footer>
      </main>
    </div>
  );
}
